import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorNotificationService } from 'src/app/services/error-notification.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-error-view',
  templateUrl: './error-view.component.html',
  styleUrls: ['./error-view.component.css']
})
export class ErrorViewComponent implements OnInit {

  @Input() errorMessage: string = 'This is a sample error message. It will show as a string with no formatiing.';

  loading:boolean = false;

  constructor(private errorSvc: ErrorNotificationService, private router: Router, private loaderSvc: LoaderService) {
  }

  ngOnInit(): void {
    this.subscribeLoader();
    this.errorSvc.errorNotification$.subscribe(e => { this.errorMessage = e; });
  }

  subscribeLoader() {
    this.loaderSvc.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }

  goHome(){
    this.router.navigate(['/']);
  }
}
